export default {
  namespased: true,
  state: {
    // wyświetla modal jeśli active jest true
    active: false,
    title: '',
    content: '',
    value: null,
    callbackYes: null,
    argsYes: null,
    callbackNo: null,
    argsNo: null
  },
  getters: {
  },
  actions: {
  },
  mutations: {
    setYesno(state,payload){
      state.active = true;
      state.content = payload[0];
      state.callbackYes = payload[1][0];
      state.argsYes = payload[1][1];
      state.callbackNo = payload[2][0];
      state.argsNo = payload[2][1];
    },

    closeYesno(state,value){
      state.active = false;
      state.content = '';
      state.value = value;
      state.callbackYes = null;
      state.argsYes = null
      state.callbackNo = null;
      state.argsNo = null
    }
  }
}